<div class="grid gap-4 xl:grid-cols-2 xl:items-start">
  <div *ngFor="let row of rows"
    class="rounded-2xl border border-gray-200 bg-white p-4 dark:border-white/10 dark:bg-[#0e1726]">
    <div class="mb-3 flex items-center justify-between gap-3">
      <h4 class="text-sm font-bold text-gray-900 dark:text-white">{{ row.label }}</h4>
      <div class="flex items-center gap-3">
        <span *ngIf="rowStatus(row)" class="text-xs font-semibold" [ngClass]="rowStatusClass(row)">
          {{ rowStatus(row) }}
        </span>
        <button *ngIf="canRecompare(row)" type="button" (click)="compareAgain(row)"
          [disabled]="isRecompareLoading(row)"
          class="inline-flex items-center gap-1.5 rounded-lg border border-gray-200 bg-white px-2.5 py-1.5 text-xs font-medium text-gray-700 hover:bg-gray-50 disabled:opacity-60 dark:border-gray-600 dark:bg-[#0e1726] dark:text-white-dark dark:hover:bg-white/5">
          <icon-refresh *ngIf="!isRecompareLoading(row)" class="size-3.5 shrink-0" />
          {{ isRecompareLoading(row) ? 'Comparing…' : 'Compare Again' }}
        </button>
      </div>
    </div>

    <div class="grid grid-cols-2 gap-3">
      <div>
        <p class="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">Captured</p>
        <img *ngIf="row.captured; else noImg" [src]="row.captured" [alt]="row.label + ' captured'"
          class="aspect-square w-72 max-w-full rounded-lg border border-gray-200 bg-gray-100 object-contain dark:border-white/10 dark:bg-gray-900" />
      </div>
      <div>
        <p class="mb-1 text-xs font-medium uppercase tracking-wide text-gray-400">{{ row.uploadedLabel }}</p>
        <img *ngIf="row.uploaded; else noImg" [src]="row.uploaded" [alt]="row.label + ' uploaded'"
          class="aspect-square w-72 max-w-full rounded-lg border border-gray-200 bg-gray-100 object-contain dark:border-white/10 dark:bg-gray-900" />
      </div>
    </div>

    <p *ngIf="recompareError(row)" class="mt-2 text-xs text-red-600 dark:text-red-400">{{ recompareError(row) }}</p>
  </div>

  <ng-template #noImg>
    <div
      class="flex aspect-square w-72 max-w-full items-center justify-center rounded-lg border border-dashed border-gray-200 text-xs text-gray-400 dark:border-white/10">
      Not available
    </div>
  </ng-template>
</div>
